import React, { useState, useEffect, useRef } from 'react';
import Header from "../../../../Components/Header/Header.js";
import LeftMenu from '../../../../Components/LeftMenu/LeftMenu.js';
import TopMenu from '../../../../Components/TopMenu/TopMenu.js';
import Export from "../../../../assets/images/export.svg";
import Exportw from "../../../../assets/images/exportw.png";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';

import Demurrage from '../Recovery/Demurrage.js';
import Missing from '../Recovery/Missing.js';
import MVTMismatch from '../Recovery/MVTMismatch.js';


import { ReactSearchAutocomplete } from 'react-search-autocomplete'
import { withRFSToken } from '../../../../Services/axios.js';
import { ULDSEARCH, ULDSEARCHDETAILS } from '../../../../Utils/conts.js';

const Invoice = () => {

   const initialTab = localStorage.getItem("Rtab") || 'demurrage';
     const [selectedButton, setSelectedButton] = useState('demurrage');
    //  useEffect(() => {
    //      setSelectedButton(initialTab);
    //  }, [initialTab]);
     const handleButtonClick = (button) => {
         setSelectedButton(button);
         localStorage.setItem('Rtab', button);
     };
 
     const isMounted = useRef(false);
     const [searchItems, setSearchItems] = useState([])
     const fetchDataGrid = async () => {
         try {
             const res = await withRFSToken.post(ULDSEARCH, {})
                 .then(function (res) {
                     const innerData = res.data.response_data;
                     const transformedData = innerData.map((name, index) => ({
                         id: index,
                         name: name
                     }));
                     setSearchItems(transformedData);
 
                 });
 
         } catch (error) {
             console.error('Error fetching data:', error);
         }
     };
     useEffect(() => {
         if (isMounted.current) return;
         // Call the fetchData function to fetch data from the API
         fetchDataGrid();
         isMounted.current = true;
     }, []);
 
     const handleOnSearch = (string, results) => {
         // onSearch will have as the first callback parameter
         // the string searched and for the second the results.
         console.log(string, results)
     }
 
     const handleOnHover = (result) => {
         // the item hovered
         console.log(result)
     }
 
     const handleOnSelect = async (item) => {
         // the item selected
         console.log(item)
         try {
             const res = await withRFSToken.post(ULDSEARCHDETAILS, { uld_number: item.name });
             if (res.data.response_code == 200) {
                 localStorage.removeItem('MHistory');
                 const storageData = {
                     ULD: res.data.response_data,  // ULD Details section
                     Form: {}  // Empty form section
                 };
                 localStorage.setItem('MHistory', JSON.stringify(storageData));
                 localStorage.setItem('Rtab', initialTab);
                 window.location.href = '/ULDControl/MovementHistory'
             }
 
         } catch (error) {
             console.error('Error fetching data:', error);
         }
     };
     const handleOnFocus = () => {
         // console.log('Focused')
     }

    return (
        <>
            <div className="">
                <Header logo_url='/ULDControl' />
                <div className="page-body-wrapper schedule">
                    <LeftMenu />
                    <div className="main-panel rounded">
                        <div className="mainTab">
                            <TopMenu module='ULD' />
                            <div className="">
                                <div className="allcontent-fl">
                                    <div className='d-flex justify-content-between mb-3'>
                                        <div>
                                            {/* <button className={selectedButton === 'missing' ? 'exportbtn me-3 active' : 'exportbtn me-3'} onClick={() => handleButtonClick('missing')}>
                                                <img src={selectedButton === 'missing' ? Exportw : Export} /> <span>Missing</span>
                                            </button>
                                            <button className={selectedButton === 'mvt' ? 'exportbtn me-3 active' : 'exportbtn me-3'} onClick={() => handleButtonClick('mvt')}>
                                                <img src={selectedButton === 'mvt' ? Exportw : Export} /> <span>MVT Mismatch</span>
                                            </button> */}
                                            <button className={selectedButton === 'demurrage' ? 'exportbtn me-3 active' : 'exportbtn me-3'} onClick={() => handleButtonClick('demurrage')}>
                                                <img src={selectedButton === 'demurrage' ? Exportw : Export} /> <span>Demurrage</span>
                                            </button>
                                            
                                        </div>
                                        <div className='search'>
                                            <div className="form-group has-search">
                                                {/* <span className="form-control-feedback"> <FontAwesomeIcon icon={faMagnifyingGlass} /></span> */}
                                                {/* <input type="text" className="form-control" placeholder="Search ULD" /> */}
                                                <ReactSearchAutocomplete
                                                    items={searchItems}
                                                    onSearch={handleOnSearch}
                                                    onHover={handleOnHover}
                                                    onSelect={handleOnSelect}
                                                    onFocus={handleOnFocus}
                                                    autoFocus
                                                    placeholder="Search ULD"
                                                // formatResult={formatResult}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="lcontent">
                                        {/* {selectedButton === 'missing' &&
                                            <Missing />
                                        }
                                        {selectedButton === 'mvt' &&
                                            <MVTMismatch />
                                        } */}
                                        {selectedButton === 'demurrage' &&
                                            <Demurrage />
                                        }
                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Invoice;